<template>
    <div class="card col-md-8 mx-auto px-0">
        <div class="loader" v-if="saving"></div>
        <div class="card-header bg-primary text-white" v-if="!saving">
            <div class="card-title h5 m-0">{{ $t('publicOrder.documents') }}</div>
        </div>
        <div class="card-body" v-if="!saving">
            <div class="form-group col-12 p-0">
                <div
                    v-for="(document,index) in filesToDownload"
                    :key="index"
                     class="mt-2 border border-light-2 p-2">
                    <div class="col-12 align-items-center k-display-flex">
                        <file-download :file="document"
                                      :showDescription="true"
                                      class="col-12"
                                      type="Document">
                        </file-download>
                        <i class="fas fa-trash-alt k-align-self-center btn-danger pointer position-relative"
                           @click="deleteDocument(document,index)" v-if="editing"></i>
                    </div>
                </div>
                <div v-for="(file,index) in filesToUpload" :key="index" class="mt-2 border border-light-2 p-2" v-if="editing">
                    <div class="k-display-flex">
                        <file-upload :file="file" :showDescription="true"
                                    class="k-align-self-end col-12"></file-upload>
                        <i class="fas fa-trash-alt k-align-self-center btn-danger pointer position-relative"
                           @click="deleteFile(index)"></i>
                    </div>
                </div>
                <button type="button" class="btn btn-primary btn-md mt-3" @click="addFile" v-if="editing">
                    <i class="fas fa-plus mr-2"></i>{{ $t('publicOrder.addFile') }}
                </button>
            </div>
        </div>
        <div class="form-group col-12" v-if="allowEdit">
            <div class="btn-group">
                <button v-if="!editing" type="button" class="btn btn-primary btn"
                        @click.stop="editing=!editing">
                    <i class="fas fa-edit"></i>
                    {{ $t('buttons.edit.btnText') }}
                </button>
                <button v-if="editing" type="button" class="btn btn-primary btn"
                        :class="saving ? 'disabled' : ''" @click.stop="uploadAndDeleteFiles">
                    <i class="fas fa-spinner fa-spin" v-if="saving"></i>
                    <i class="fas fa-save" v-else></i>
                    {{ $t('buttons.save.btnText') }}
                </button>
                <button v-if="editing" type="button" class="btn btn-danger btn"
                        :class="saving ? 'disabled' : ''" @click.stop="cancelEdit">
                    <i class="fas fa-ban"></i>
                    {{ $t('buttons.cancel') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import FileUpload from "../common/FileUpload";
    import FileDownload from "../common/FileDownload";
    import { File, FileDetails } from "../../models/file.models";
    import personService from "../../services/person.service";

    export default {
        name: "PersonalFiles",
        components: {
            FileUpload,
            FileDownload,
        },
        props: {
            userId: {
                type: String,
                default: null
            },
            allowEdit: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                filesToUpload: [],
                filesToDownload: [],
                deletedDocumentsIds: [],
                saving: false,
                editing: false,
                personId: null,
            }
        },
        methods: {
            addFile() {
                this.filesToUpload.push(new File())
            },
            deleteFile: function (m) {
                this.filesToUpload.splice(m, 1);
            },
            deleteDocument: function (doc, index) {
                this.deletedDocumentsIds.push(doc.id);
                this.filesToDownload.splice(index, 1);
            },
            cancelEdit() {
                this.editing = false;
                this.loadFiles();
            },
            resetFileData() {
                this.filesToUpload = [];
                this.filesToDownload = [];
                this.deletedDocumentsIds = [];
            },
            uploadAndDeleteFiles() {
                if (this.personId) {
                    this.uploadFiles(this.personId);
                }
                if (this.personId && this.deletedDocumentsIds.length > 0) {
                    this.deleteFiles();
                }
                this.editing = false;
            },
            uploadFiles(personId) {
                // TODO: Loading with upload files text for example
                this.saving = true;
                if (this.filesToUpload.length > 0) {
                    let formData = new FormData();
                    let descriptions = [];
                    this.filesToUpload.forEach(file => {
                        if (file.content.size) {
                            formData.append('files', file.content, file.fileName);
                            descriptions.push({
                                fileName: file.fileName,
                                description: file.fileDescription,
                                length: file.content.size
                            });
                        }
                    });

                    try {
                        const descJson = JSON.stringify(descriptions);
                        formData.append('descriptionJson', descJson);
                    } catch (e) {
                        console.error(e);
                    }

                    this.$http.post(`/api/person/uploadFiles/${personId}`, formData).then(result => {
                        this.saving = false;
                        this.loadFiles();
                        this.$vs.notify({
                            title: this.$t('notifications.success'),
                            text: this.$t('notifications.successUploadingFiles'),
                            position: 'top-center',
                            color: 'success'
                        });
                    }).catch(error => {
                        this.saving = false;
                        this.$vs.notify({
                            title: this.$t('notifications.error'),
                            text: this.$t('notifications.errorUploadingFiles'),
                            position: 'top-center',
                            color: 'danger'
                        });
                    });
                }
            },
            deleteFiles() {
                this.saving = true;
                personService.deleteFiles(this.deletedDocumentsIds, this.personId)
                    .then(response => {
                        this.loadFiles();
                        this.saving = false;
                        this.$vs.notify({
                            title: this.$t('notifications.success'),
                            text: this.$t('notifications.successfulDeletedData'),
                            position: 'top-center',
                            color: 'success'
                        });
                    }).catch(error => {
                        this.saving = false;
                        this.$vs.notify({
                            title: this.$t('notifications.error'),
                            text: this.$t('notifications.errorUploadingFiles'),
                            position: 'top-center',
                            color: 'danger'
                        });
                    })
            },
            getPersonByUserId() {
                personService.getByUserId(this.userId).then(result => {
                    if (result) {
                        this.personId = result.data.id;
                    }
                })
                    .catch(error => {

                    })
            },
            loadFiles() {
                this.resetFileData();
                if (!this.personId) {
                    this.getPersonByUserId();
                }
                if (this.personId) {
                    this.saving = true;
                    personService
                        .getPersonFilesById(this.personId)
                        .then(result => {
                            this.saving = false;
                            if (result) {
                                result.data.forEach(file => {
                                    this.filesToDownload.push(new FileDetails(file));
                                })
                            }
                        }).catch(error => {
                            this.saving = false;
                            this.$vs.notify({
                                title: this.$t('notifications.error'),
                                text: this.$t('notifications.errorLoadingData'),
                                position: 'top-center',
                                color: 'danger'
                            });
                        })
                }
            },
        },
        watch: {
            personId(newVal) {
                if (newVal) {
                    this.loadFiles();
                }
            }
        },
        mounted() {
            if (this.userId) {
                this.getPersonByUserId();
            }
        }
    }
</script>

<style scoped>
</style>
